import { FormControl, FormLabel, Select } from "@chakra-ui/react";
import theme from "../../../../../Constants/theme";
import getConfigurations, {
  WeightOptions,
} from "../../../../../Constants/ExercisesOptions";
import { useUser } from "../../../../../Contexts/UserContext";
import { CreateOrUpdateWorkoutState } from "../../../../../Hooks/HookHelpers/validation";

interface ExerciseWeightUnitProps {
  weightUnitIsInvalid: boolean;
  exercise: Omit<CreateOrUpdateWorkoutState["exercises"][number], "key">;
  exerciseIndex: number;
  handleExercise: (name: string, value: string | number, index: number) => void;
}

export default function ExerciseWeightUnit({
  weightUnitIsInvalid,
  exercise,
  exerciseIndex,
  handleExercise,
}: ExerciseWeightUnitProps) {
  const user = useUser().user;
  const templates = user?.templates ?? [];
  const Preconfigurations = getConfigurations(templates, {
    bodyWeight: user?.bodyWeight ?? 0,
    bodyWeightUnit: user?.bodyWeightUnit ?? "kg",
  });
  // Not all Preconfigurations have a bodyweight. If they do, use it. Otherwise, check user context.
  const usingBodyWeight =
    Preconfigurations[exercise.title.value]?.isBodyWeight?.value !== undefined
      ? Preconfigurations[exercise.title.value]?.isBodyWeight?.value
      : user?.templates?.some(
          (template) =>
            template.isBodyWeight && template.title === exercise.title.value
        );

  return (
    <FormControl isInvalid={weightUnitIsInvalid}>
      <FormLabel fontSize={["14px", "16px"]} m="0">
        Unit
      </FormLabel>

      <Select
        fontSize={["16px"]}
        size={["sm", "sm", "md"]}
        placeholder="Select"
        name="weightUnit"
        value={exercise.weightUnit.value}
        onChange={(event) =>
          handleExercise(event.target.name, event.target.value, exerciseIndex)
        }
        focusBorderColor={theme.colors.green[300]}
        color={
          !!exercise.weightUnit.value
            ? theme.colors.black
            : theme.colors.grey[500]
        }
        disabled={usingBodyWeight}
      >
        {WeightOptions.map((option) => {
          return (
            <option key={option.label} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </Select>
    </FormControl>
  );
}
